function getIframeWindow(iframe) {
  return iframe.contentWindow || iframe;
}

export default getIframeWindow;
